module.exports = "https://static.futunn.com/components/common-offline-activity-session/images/bg-card.38699f05d4.png";